import { useGetSocialEffect } from '../effect';
import { GetSocialProps, GetSocialTemplateProps } from '../interfaces';
import { GetSocialDefaultTemplate } from '../templates';

export const GetSocialSegment = (props: GetSocialProps) => {
  const [state] = useGetSocialEffect(props);

  const templateProps: GetSocialTemplateProps = {
    id: props.id,
    hrefLink: props.hrefLink,
    slots: props.slots,
    ...state,
  };

  let template;
  switch (props.template) {
    case 'getSocialDefault':
    default:
      template = GetSocialDefaultTemplate(templateProps);
      break;
  }

  return template;
};
